import './HallAppContainer.scss';

function HallAppContainer({ children, style }) {
    return (
        <div>
            <div style={style} className='container-hallapp-wrapper'>
                <div className='container container-hallapp'>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default HallAppContainer;